<nav class="sidenav bg-dark navbar-dark">
  <div class="w-100 d-flex flex-column flex-shrink-0 p-2 text-white bg-dark">
    <a class="d-flex align-items-center mb-0 text-white text-decoration-none" routerLink="/">
      <div class="logo-container"></div>
    </a>
    <hr class="border-primary" />
    <ul id="navBarMain" class="navbar-nav flex-column mb-auto">
      <li style="text-align:center;" *ngIf="!pagesLoaded">
        <div class="spinner-border spinner-border-smtext-customer"></div>
      </li>
      <div *ngIf="pagesLoaded">
        <li *ngFor="let page of pages">
          <a class="nav-link" routerLink="/{{ page.tabPath }}" routerLinkActive="active-link"
            (click)="component(page.tabPath)">
            <i class="{{ page.iconFile }} me-2 w-15 fa-lg"></i>{{ "DCO.Pages_" + page.tabName | translate }}
          </a>
        </li>
      </div>
    </ul>
  </div>
</nav>
<header>
  <div class="clearfix header-main">
    <div class="logo-container-header float-start"></div>
    <!-- Contenedor del Dropdown -->
    <div class="dropdown float-end">
      <button class="btn btn-link text-dark fw-semibold small dropdown-toggle d-flex align-items-center" type="button"
        (click)="menuAbierto = !menuAbierto; $event.stopPropagation()">
        <i class="fas fa-user-circle me-2 fa-2x"></i>
        {{ username ? username : ('Login' | translate) }}
      </button>

      <!-- Menú con clase dinámica 'show' de Bootstrap -->
      <ul class="dropdown-menu dropdown-menu-end shadow border-0" [class.show]="menuAbierto"
        style="right: 0; left: auto; background-color: white;">

        <li>
          <a class="dropdown-item d-flex align-items-center" routerLink="/profile" (click)="menuAbierto = false">
            <i class="fas fa-user me-2"></i>
            {{"DCO.Title_Profile" | translate}}
          </a>
        </li>

        <li *ngIf="allowHelp">
          <a class="dropdown-item d-flex align-items-center" routerLink="/help" (click)="menuAbierto = false">
            <i class="fas fa-question-circle me-2"></i>
            {{"DCO.Title_Help" | translate}}
          </a>
        </li>

        <!-- Selector de Idioma -->
        <li class="px-3 py-2" (click)="$event.stopPropagation()">
          <div class="d-flex align-items-center" style="min-width: 150px;">
            <i class="fas fa-globe me-2 text-muted"></i>
            <select class="form-select form-select-sm border-1" [(ngModel)]="selectedLanguage"
              (change)="SetLanguage(selectedLanguage); menuAbierto = false">
              <option *ngFor="let language of languages" [value]="language">
                {{ language }}
              </option>
            </select>
          </div>
        </li>

        <li>
          <hr class="dropdown-divider">
        </li>

        <!-- Opción de Logout / Login -->
        <li *ngIf="username; else loginLink">
          <button class="dropdown-item text-danger d-flex align-items-center" (click)="logOut(); menuAbierto = false">
            <i class="fas fa-sign-out-alt me-2"></i> {{"DCO.Title_SignOut" | translate}}
          </button>
        </li>

        <ng-template #loginLink>
          <li>
            <a class="dropdown-item d-flex align-items-center" routerLink="/login" (click)="menuAbierto = false">
              <i class="fas fa-sign-in-alt me-2"></i> Login
            </a>
          </li>
        </ng-template>
      </ul>
    </div>
  </div>
</header>